// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1C16_","sendOtp":"AuthorizeToLogin_sendOtp__24-Gw"};